import Hamsa from './Hamsa'

export default Hamsa
// eslint-disable-next-line import/export
export * from './Hamsa'
